import { Button, Dialog, Text } from '@cascade/ui-library';
import classes from './ConfirmDialog.module.scss';
import type { TConfirmDialogProps } from './ConfirmDialog.types.ts';

export const ConfirmDialog = ({
  title,
  description,
  notice,
  confirmLabel,
  cancelLabel,
  closeLabel,
  isDestructive = false,
  isPending = false,
  onConfirm,
  onClose,
}: TConfirmDialogProps) => (
  <Dialog
    open
    size='sm'
    title={title}
    subtitle={description}
    closeLabel={closeLabel}
    dismissible={!isPending}
    footer={
      <div className={classes.actions}>
        <Button
          variant='secondary'
          label={cancelLabel}
          disabled={isPending}
          onClick={onClose}
        />
        <Button
          variant={isDestructive ? 'danger' : 'primary'}
          iconType={isDestructive ? 'trash' : undefined}
          label={confirmLabel}
          disabled={isPending}
          onClick={onConfirm}
        />
      </div>
    }
    onClose={onClose}
  >
    {notice ? <Text type='body-2' content={notice} /> : null}
  </Dialog>
);
